import { type ReactNode, useState } from 'react';

interface RLinkProps {
  href: string;
  children: ReactNode;
  chevron?: boolean;
  color?: string;
  target?: string;
  rel?: string;
}

export function RLink({
  href,
  children,
  chevron = false,
  color,
  target,
  rel,
}: RLinkProps) {
  const [hover, setHover] = useState(false);
  return (
    <a
      href={href}
      target={target}
      rel={rel}
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 6,
        color: color || 'var(--accent)',
        fontWeight: 500,
        borderBottom: hover
          ? '1px solid var(--accent)'
          : '1px solid transparent',
        paddingBottom: 1,
        transition: 'border-color 160ms var(--ease-out)',
      }}
    >
      <span>{children}</span>
      {chevron && (
        <span
          style={{
            display: 'inline-block',
            transition: 'transform 160ms var(--ease-out)',
            transform: hover ? 'translateX(3px)' : 'translateX(0)',
          }}
        >
          →
        </span>
      )}
    </a>
  );
}
